import { render } from "./InputProductInfo.vue?vue&type=template&id=bcb633de"
import script from "./InputProductInfo.vue?vue&type=script&lang=js"
export * from "./InputProductInfo.vue?vue&type=script&lang=js"

import "./InputProductInfo.vue?vue&type=style&index=0&id=bcb633de&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__